import React, { useEffect, useState, useContext, useRef } from "react";
import { ThemeContext } from "../../App";
import Swal from "sweetalert2";
import axios from "axios";
import { GrUserAdmin } from "react-icons/gr";

const Rhyms = ({ Ip }) => {
  const { isDark } = useContext(ThemeContext);
  const [data, setData] = useState([]);

  const [editData, setEditData] = useState(null);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchColumn, setSearchColumn] = useState("all");
  const [access_role, setAccessRole] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [bulkColumn, setBulkColumn] = useState("album");
  const [bulkValue, setBulkValue] = useState("");
  const [adminUsername, setAdminUsername] = useState("");
  const [currentAudioTitle, setCurrentAudioTitle] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [sortOrder, setSortOrder] = useState(null);
  const audioRef = useRef(null);

  useEffect(() => {
    const storedAdmin = localStorage.getItem("admin_info");
    const admin = storedAdmin ? JSON.parse(storedAdmin) : null;
    if (admin) {
      setAccessRole(Number(admin.accessLvl));
      setAdminUsername(admin.username);
    }
  }, []);

  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, []);

  const handleAudioPlay = async (title) => {
    if (!title) return;

    const audioUrl = `${Ip}/assets/songs/${title}.mp3`;

    if (currentAudioTitle !== title) {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }

      audioRef.current = new Audio(audioUrl);
      audioRef.current.addEventListener("ended", () => {
        setIsPlaying(false);
        setCurrentAudioTitle(null);
      });
      audioRef.current.addEventListener("error", () => {
        Swal.fire("Audio Error", "Cannot play this audio file.", "error");
        setIsPlaying(false);
        setCurrentAudioTitle(null);
      });

      try {
        await audioRef.current.play();
        setCurrentAudioTitle(title);
        setIsPlaying(true);
      } catch (err) {
        Swal.fire("Audio Error", "Cannot play this audio file.", "error");
        setIsPlaying(false);
        setCurrentAudioTitle(null);
      }
    } else {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        try {
          await audioRef.current.play();
          setIsPlaying(true);
        } catch (err) {
          Swal.fire("Audio Error", "Cannot play this audio file.", "error");
          setIsPlaying(false);
          setCurrentAudioTitle(null);
        }
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const formData = new FormData();
      formData.append("action", "get");
      const res = await axios.post(`${Ip}/Dashboard/rhyms.php`, formData);
      setData(res.data.data);
    } catch (err) {
      console.log(err);
    } finally {
    }
  };

  const handleEdit = (row) => {
    setEditData({ ...row, imageFile: null, audioFile: null });
    setShowModalEdit(true);
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this item!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Use URLSearchParams to send as form data
          const formData = new URLSearchParams();
          formData.append("action", "delete");
          formData.append("id", id);

          const res = await axios.post(`${Ip}/Dashboard/rhyms.php`, formData);

          if (res.data.success) {
            Swal.fire("Deleted!", "Item deleted successfully.", "success");
            fetchData();
          } else {
            Swal.fire("Error", "Delete failed.", "error");
          }
        } catch {
          Swal.fire("Error", "Something went wrong.", "error");
        }
      }
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditData({ ...editData, [name]: value });
  };

  const handleUpdate = async () => {
    try {
      const formData = new FormData();
      formData.append("action", "edit");

      Object.entries(editData).forEach(([key, value]) => {
        if (key === "imageFile") return; // skip imageFile, handle below
        if (key === "image") return; // handle image below
        if (key === "audioFile") return; // skip audioFile, handle below
        if (key === "audio") return; // handle audio below
        formData.append(key, value);
      });
      if (adminUsername) {
        formData.append("admin", adminUsername);
      }

      // If a new image file is selected, append it
      if (editData.imageFile) {
        formData.append("image", editData.imageFile);
      } else {
        // Otherwise, send the image path as a string
        if (editData.image) {
          formData.append("image", editData.image);
        }
      }

      // If a new audio file is selected, append it; otherwise send existing path if present
      if (editData.audioFile) {
        formData.append("audio", editData.audioFile);
      } else if (editData.audio) {
        formData.append("audio", editData.audio);
      }

      const res = await axios.post(`${Ip}/Dashboard/rhyms.php`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data.success) {
        Swal.fire("Updated!", "Rhyme updated successfully.", "success");
        fetchData();
        setShowModalEdit(false);
      } else {
        Swal.fire("Error", "Update failed.", "error");
      }
    } catch {
      Swal.fire("Error", "Something went wrong.", "error");
    }
  };
  const [addData, setAddData] = useState({
    name: "",
    title: "",
    artist: "",
    album: "",
    length: "",
    composer: "",
    musicarrangement: "",
    rite: "",
    occasion: "",
    times: "",
  });

  const handleAddInputChange = (e) => {
    const { name, value } = e.target;
    setAddData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAdd = async () => {
    try {
      const formData = new FormData();
      formData.append("action", "add");
      if (adminUsername) {
        formData.append("admin", adminUsername);
      }
      // Append text fields
      Object.entries(addData).forEach(([key, value]) => {
        formData.append(key, value);
      });

      // Append the image file (only 1)
      if (addData.imageFile) {
        formData.append("image", addData.imageFile);
      }

      // Append the audio file (only .mp3)
      if (addData.audioFile) {
        formData.append("audio", addData.audioFile);
      }

      const res = await axios.post(`${Ip}/Dashboard/rhyms.php`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data.success) {
        Swal.fire("Added!", "Rhyme added successfully.", "success");
        fetchData();
        setShowModalAdd(false);
        setAddData({
          name: "",
          title: "",
          artist: "",
          album: "",
          length: "",
          composer: "",
          musicarrangement: "",
          rite: "",
          occasion: "",
          times: "",
        });
      } else {
        Swal.fire("Error", "Add failed.", "error");
      }
    } catch {
      Swal.fire("Error", "Something went wrong.", "error");
    }
  };

  // const filterData = () => {
  //   return data.filter((row) => {
  //     if (!searchTerm) return true; // no filter if searchTerm is empty

  //     const term = searchTerm.toLowerCase();

  //     if (searchColumn === "all") {
  //       return Object.values(row).some(
  //         (val) => val && val.toString().toLowerCase().includes(term),
  //       );
  //     } else {
  //       return (
  //         row[searchColumn] &&
  //         row[searchColumn].toString().toLowerCase().includes(term)
  //       );
  //     }
  //   });
  // };

  const filterData = () => {
    const filtered = data.filter((row) => {
      if (!searchTerm) return true;

      const term = searchTerm.toLowerCase();

      if (searchColumn === "all") {
        return Object.values(row).some(
          (val) => val && val.toString().toLowerCase().includes(term),
        );
      }

      return (
        row[searchColumn] &&
        row[searchColumn].toString().toLowerCase().includes(term)
      );
    });

    if (sortOrder === null) {
      return filtered;
    }

    const column = searchColumn === "all" ? "name" : searchColumn;

    return filtered.sort((a, b) => {
      const valueA = (a[column] || "").toString().toLowerCase();
      const valueB = (b[column] || "").toString().toLowerCase();

      return sortOrder === "asc"
        ? valueA.localeCompare(valueB)
        : valueB.localeCompare(valueA);
    });
  };

  const handleBulkUpdateAlbum = async () => {
    if (!bulkValue || selectedRows.length === 0) return;

    try {
      const formData = new URLSearchParams();
      formData.append("action", "bulk_update_column");
      formData.append("column", bulkColumn);
      formData.append("value", bulkValue);
      formData.append("ids", JSON.stringify(selectedRows));
      if (adminUsername) {
        formData.append("admin", adminUsername);
      }

      const res = await axios.post(`${Ip}/Dashboard/rhyms.php`, formData);

      if (res.data.success) {
        Swal.fire("Updated!", "Selected rows updated successfully.", "success");
        fetchData();
        setSelectedRows([]);
        setBulkValue("");
        setShowBulkModal(false);
      } else {
        Swal.fire("Error", "Update failed.", "error");
      }
    } catch (err) {
      Swal.fire("Error", "Something went wrong.", "error");
    }
  };
  return (
    <div className="p-4">
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between mb-6">
        <div>
          <h1 className="text-2xl font-semibold">Rhymes</h1>
          <p className="text-light-muted dark:text-dark-muted text-sm">
            Manage and curate your catalog
          </p>
        </div>
        {selectedRows.length > 0 && (
          <button
            onClick={() => setShowBulkModal(true)}
            className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg transition-colors"
          >
            Replace
          </button>
        )}
        <div className="flex items-center gap-2 w-full md:w-auto">
          <div className="flex items-center gap-2 w-full md:w-auto">
            <div className="relative flex-1 md:w-80">
              <input
                type="text"
                placeholder="Search…"
                className="w-full pl-9 pr-3 py-2 rounded-lg bg-light-surfaceSoft dark:bg-dark-surfaceSoft border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
              />
              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-light-muted dark:text-dark-muted">
                🔎
              </span>
            </div>
            <select
              className="p-2 rounded-lg border border-light-border dark:border-dark-border bg-light-surface dark:bg-dark-surface text-light-text dark:text-dark-text"
              value={searchColumn}
              onChange={(e) => setSearchColumn(e.target.value)}
            >
              <option value="all">All</option>
              <option value="name">Name</option>
              <option value="title">Title</option>
              <option value="titlear">Title (AR)</option>
              <option value="artist">Artist</option>
              <option value="artistar">Artist (AR)</option>
              <option value="album">Album</option>
              <option value="albumar">Album (AR)</option>
              <option value="composer">Composer</option>
              <option value="composerar">Composer (AR)</option>
              <option value="musicarrangement">Arrangement</option>
              <option value="musicarrangementar">Arrangement (AR)</option>
              <option value="rite">Rite</option>
              <option value="ritear">Rite (AR)</option>
              <option value="occasion">Occasion</option>
              <option value="occasionar">Occasion (AR)</option>
              <option value="times">Times</option>
              <option value="keywords">keywords</option>
              <option value="keywordsar">keywords (AR)</option>
            </select>
          </div>
          <button
            onClick={() =>
              setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"))
            }
            className="inline-flex items-center gap-2 bg-light-brand hover:bg-light-brandHover dark:bg-dark-brand dark:hover:bg-dark-brandHover active:bg-light-brand dark:active:bg-dark-brand transition-colors px-4 py-2 rounded-lg text-white"
          >
            {sortOrder === "asc" ? "A → Z" : "Z → A"}
          </button>
          {(access_role === 1 || access_role === 2) && (
            <button
              onClick={() => setShowModalAdd(true)}
              className="inline-flex items-center gap-2 bg-light-brand hover:bg-light-brandHover dark:bg-dark-brand dark:hover:bg-dark-brandHover active:bg-light-brand dark:active:bg-dark-brand transition-colors px-4 py-2 rounded-lg text-white"
            >
              <span>＋</span>
              <span>Add</span>
            </button>
          )}
        </div>
      </div>

      <div className="overflow-x-auto rounded-lg border border-light-border dark:border-dark-border bg-light-surface dark:bg-dark-surface transition-colors">
        <table className="min-w-[2500px] table-auto">
          <thead className="bg-light-surfaceSoft dark:bg-dark-surfaceSoft text-left text-light-textSecondary dark:text-dark-textSecondary">
            <tr>
              <th className="px-4 py-3 text-sm font-medium">Select</th>
              <th className="px-4 py-3 text-sm font-medium">ID</th>
              <th className="px-4 py-3 text-sm font-medium">Name</th>
              <th className="px-4 py-3 text-sm font-medium">Title</th>
              <th className="px-4 py-3 text-sm font-medium">Title (AR)</th>
              <th className="px-4 py-3 text-sm font-medium">Artist</th>
              <th className="px-4 py-3 text-sm font-medium">Artist (AR)</th>
              <th className="px-4 py-3 text-sm font-medium">Album</th>
              <th className="px-4 py-3 text-sm font-medium">Album (AR)</th>
              <th className="px-4 py-3 text-sm font-medium">Length</th>
              <th className="px-4 py-3 text-sm font-medium">Lyrics</th>
              <th className="px-4 py-3 text-sm font-medium">Lyrics (AR)</th>
              <th className="px-4 py-3 text-sm font-medium">Composer</th>
              <th className="px-4 py-3 text-sm font-medium">Composer (AR)</th>
              <th className="px-4 py-3 text-sm font-medium">Arrangement</th>
              <th className="px-4 py-3 text-sm font-medium">
                Arrangement (AR)
              </th>
              <th className="px-4 py-3 text-sm font-medium">Rite</th>
              <th className="px-4 py-3 text-sm font-medium">Rite (AR)</th>
              <th className="px-4 py-3 text-sm font-medium">Occasion</th>
              <th className="px-4 py-3 text-sm font-medium">Occasion (AR)</th>
              <th className="px-4 py-3 text-sm font-medium">Times</th>
              <th className="px-4 py-3 text-sm font-medium">Image</th>
              <th className="px-4 py-3 text-sm font-medium">Audio</th>
              <th className="px-4 py-3 text-sm font-medium">
                Last Modified By
              </th>
              <th className="px-4 py-3 text-sm font-medium">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-light-border/50 dark:divide-dark-border/50">
            {filterData().map((row) => (
              <tr
                key={row.id}
                className="hover:bg-light-surfaceSoft/50 dark:hover:bg-dark-surfaceSoft/50 transition-colors"
              >
                <td className="px-4 py-3 align-top">
                  <input
                    type="checkbox"
                    checked={selectedRows.includes(row.id)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedRows([...selectedRows, row.id]);
                      } else {
                        setSelectedRows(
                          selectedRows.filter((id) => id !== row.id),
                        );
                      }
                    }}
                  />
                </td>
                <td className="px-4 py-3 align-top">{row.id}</td>
                <td className="px-4 py-3 align-top">{row.name}</td>
                <td className="px-4 py-3 align-top">{row.title}</td>
                <td className="px-4 py-3 align-top">{row.titlear}</td>
                <td className="px-4 py-3 align-top">{row.artist}</td>
                <td className="px-4 py-3 align-top">{row.artistar}</td>
                <td className="px-4 py-3 align-top">{row.album}</td>
                <td className="px-4 py-3 align-top">{row.albumar}</td>
                <td className="px-4 py-3 align-top">{row.length}</td>
                <td className="px-4 py-3 align-top max-w-[400px] whitespace-pre-wrap">
                  {row.lyrics}
                </td>
                <td className="px-4 py-3 align-top max-w-[400px] whitespace-pre-wrap">
                  {row.lyricsar}
                </td>
                <td className="px-4 py-3 align-top">{row.composer}</td>
                <td className="px-4 py-3 align-top">{row.composerar}</td>
                <td className="px-4 py-3 align-top">{row.musicarrangement}</td>
                <td className="px-4 py-3 align-top">
                  {row.musicarrangementar}
                </td>
                <td className="px-4 py-3 align-top">{row.rite}</td>
                <td className="px-4 py-3 align-top">{row.ritear}</td>
                <td className="px-4 py-3 align-top">{row.occasion}</td>
                <td className="px-4 py-3 align-top">{row.occasionar}</td>
                <td className="px-4 py-3 align-top">{row.times}</td>
                <td className="px-4 py-3 align-top">
                  {row.image ? (
                    <img
                      src={`${Ip}/${row.image}`}
                      alt="img"
                      className="w-10 h-10 object-cover rounded"
                    />
                  ) : (
                    <span className="text-light-muted dark:text-dark-muted">
                      No Image
                    </span>
                  )}
                </td>
                <td className="px-4 py-3 align-top">
                  {row.title ? (
                    <button
                      onClick={() => handleAudioPlay(row.title)}
                      className="px-2 py-1 rounded transition-colors text-white bg-light-brand dark:bg-dark-brand hover:bg-light-brandHover dark:hover:bg-dark-brandHover"
                    >
                      {currentAudioTitle === row.title && isPlaying
                        ? "Pause"
                        : "Play"}
                    </button>
                  ) : (
                    <span className="text-light-muted dark:text-dark-muted">
                      No Audio
                    </span>
                  )}
                </td>
                <td className="px-4 py-3 align-top flex items-center gap-2">
                  {row.last_modified_by?.trim() && (
                    <>
                      <GrUserAdmin size={30} className="text-red-500" />
                      <span className="font-semibold text-red-600">
                        {row.last_modified_by}
                      </span>
                      <span className="text-gray-500 italic text-sm">
                        at {row.last_modified_at}
                      </span>
                    </>
                  )}
                </td>
                {(access_role === 1 || access_role === 2) && (
                  <td className="px-4 py-3 align-top">
                    <div className="flex items-center gap-2">
                      <button
                        onClick={() => handleEdit(row)}
                        className="px-3 py-1.5 rounded-md bg-light-brand hover:bg-light-brandHover dark:bg-dark-brand dark:hover:bg-dark-brandHover active:bg-light-brand dark:active:bg-dark-brand transition-colors text-white text-sm"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(row.id)}
                        className="px-3 py-1.5 rounded-md bg-light-danger hover:bg-light-danger/90 dark:bg-dark-danger dark:hover:bg-dark-danger/90 active:bg-light-danger dark:active:bg-dark-danger transition-colors text-white text-sm"
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showBulkModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-light-surfaceSoft dark:bg-dark-surfaceSoft text-light-text dark:text-dark-text border border-light-border dark:border-dark-border p-6 rounded-xl w-full max-w-md shadow-2xl transition-colors">
            <h2 className="text-xl font-bold mb-4">Bulk Edit</h2>

            <div className="flex flex-col gap-4">
              <label className="flex flex-col">
                Column to update
                <select
                  value={bulkColumn}
                  onChange={(e) => setBulkColumn(e.target.value)}
                  className="p-2 rounded-lg border border-light-border dark:border-dark-border bg-light-surface dark:bg-dark-surface text-light-text dark:text-dark-text"
                >
                  <option value="album">Album</option>
                  <option value="albumar">Album (AR)</option>
                  <option value="occasion">Occasion</option>
                  <option value="occasionar">Occasion (AR)</option>
                  <option value="rite">Rite</option>
                  <option value="ritear">Rite (AR)</option>
                </select>
              </label>

              <label className="flex flex-col">
                New value
                <input
                  type="text"
                  value={bulkValue}
                  onChange={(e) => setBulkValue(e.target.value)}
                  className="p-2 rounded-lg border border-light-border dark:border-dark-border bg-light-surface dark:bg-dark-surface text-light-text dark:text-dark-text"
                />
              </label>
            </div>

            <div className="flex justify-end mt-6 gap-2">
              <button
                onClick={() => setShowBulkModal(false)}
                className="px-4 py-2 rounded-lg border border-light-border dark:border-dark-border text-light-text dark:text-dark-text hover:bg-light-surfaceSoft dark:hover:bg-dark-surfaceSoft transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  handleBulkUpdateAlbum();
                }}
                className="px-4 py-2 bg-light-brand hover:bg-light-brandHover dark:bg-dark-brand dark:hover:bg-dark-brandHover text-white rounded"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}

      {showModalEdit && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-light-surfaceSoft dark:bg-dark-surfaceSoft text-light-text dark:text-dark-text border border-light-border dark:border-dark-border p-6 rounded-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto shadow-2xl transition-colors">
            <h2 className="text-xl font-bold mb-4">Edit Rhyme</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <label className="flex flex-col">
                name
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="name"
                  value={editData.name}
                  onChange={handleInputChange}
                  placeholder="Name"
                />
              </label>
              <label className="flex flex-col">
                title
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="title"
                  value={editData.title}
                  onChange={handleInputChange}
                  placeholder="Title"
                />
              </label>
              <label className="flex flex-col">
                title (AR)
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="titlear"
                  value={editData.titlear}
                  onChange={handleInputChange}
                  placeholder="Title (AR)"
                />
              </label>
              <label className="flex flex-col">
                artist
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="artist"
                  value={editData.artist}
                  onChange={handleInputChange}
                  placeholder="Artist"
                />
              </label>
              <label className="flex flex-col">
                artist (AR)
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="artistar"
                  value={editData.artistar}
                  onChange={handleInputChange}
                  placeholder="Artist (AR)"
                />
              </label>
              <label className="flex flex-col">
                album
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="album"
                  value={editData.album}
                  onChange={handleInputChange}
                  placeholder="Album"
                />
              </label>
              <label className="flex flex-col">
                album (AR)
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="albumar"
                  value={editData.albumar}
                  onChange={handleInputChange}
                  placeholder="Album (AR)"
                />
              </label>
              <label className="flex flex-col">
                length
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="length"
                  value={editData.length}
                  onChange={handleInputChange}
                  placeholder="Length"
                />
              </label>
              <label className="flex flex-col">
                Lyrics
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="lyrics"
                  value={editData.lyrics}
                  onChange={handleInputChange}
                  placeholder="Lyrics"
                />
              </label>
              <label className="flex flex-col">
                Lyrics (AR)
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="lyricsar"
                  value={editData.lyricsar}
                  onChange={handleInputChange}
                  placeholder="Lyrics (AR)"
                />
              </label>
              <label className="flex flex-col">
                composer
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="composer"
                  value={editData.composer}
                  onChange={handleInputChange}
                  placeholder="Composer"
                />
              </label>
              <label className="flex flex-col">
                composer (AR)
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="composerar"
                  value={editData.composerar}
                  onChange={handleInputChange}
                  placeholder="Composer (AR)"
                />
              </label>
              <label className="flex flex-col">
                musicarrangement
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="musicarrangement"
                  value={editData.musicarrangement}
                  onChange={handleInputChange}
                  placeholder="Music Arrangement"
                />
              </label>
              <label className="flex flex-col">
                musicarrangement (AR)
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="musicarrangementar"
                  value={editData.musicarrangementar}
                  onChange={handleInputChange}
                  placeholder="Music Arrangement (AR)"
                />
              </label>
              <label className="flex flex-col">
                rite
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="rite"
                  value={editData.rite}
                  onChange={handleInputChange}
                  placeholder="Rite"
                />
              </label>
              <label className="flex flex-col">
                rite (AR)
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="ritear"
                  value={editData.ritear}
                  onChange={handleInputChange}
                  placeholder="Rite (AR)"
                />
              </label>
              <label className="flex flex-col">
                occasion
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="occasion"
                  value={editData.occasion}
                  onChange={handleInputChange}
                  placeholder="Occasion"
                />
              </label>
              <label className="flex flex-col">
                occasion (AR)
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="occasionar"
                  value={editData.occasionar}
                  onChange={handleInputChange}
                  placeholder="Occasion (AR)"
                />
              </label>
              <label className="flex flex-col">
                Keywords
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="keywords"
                  value={editData.keywords}
                  onChange={handleInputChange}
                  placeholder="Keywords"
                />
              </label>
              <label className="flex flex-col">
                Keywords (AR)
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="keywordsar"
                  value={editData.keywordsar}
                  onChange={handleInputChange}
                  placeholder="Keywords (AR)"
                />
              </label>
              <label className="flex flex-col">
                Times
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="times"
                  value={editData.times}
                  onChange={handleInputChange}
                  placeholder="Times"
                />
              </label>
              <label className="flex flex-col">
                Image
                <input
                  type="file"
                  name="image"
                  accept="image/*"
                  onChange={(e) =>
                    setEditData((prev) => ({
                      ...prev,
                      imageFile: e.target.files[0],
                    }))
                  }
                />
              </label>
              <label className="flex flex-col">
                Audio (.mp3)
                <input
                  type="file"
                  name="audio"
                  accept="audio/mpeg"
                  onChange={(e) =>
                    setEditData((prev) => ({
                      ...prev,
                      audioFile: e.target.files[0],
                    }))
                  }
                />
              </label>
            </div>

            <div className="flex justify-end mt-6 gap-2">
              <button
                onClick={() => {
                  setShowModalEdit(false);
                }}
                className="px-4 py-2 rounded-lg border border-light-border dark:border-dark-border text-light-text dark:text-dark-text hover:bg-light-surfaceSoft dark:hover:bg-dark-surfaceSoft transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={showModalEdit ? handleUpdate : handleAdd}
                className="bg-light-brand hover:bg-light-brandHover dark:bg-dark-brand dark:hover:bg-dark-brandHover active:bg-light-brand dark:active:bg-dark-brand transition-colors px-4 py-2 rounded-lg text-white"
              >
                Edit
              </button>
            </div>
          </div>
        </div>
      )}

      {showModalAdd && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-light-surfaceSoft dark:bg-dark-surfaceSoft text-light-text dark:text-dark-text border border-light-border dark:border-dark-border p-6 rounded-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto shadow-2xl transition-colors">
            <h2 className="text-xl font-bold mb-4">Add Rhyme</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <label className="flex flex-col">
                name
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="name"
                  value={addData.name}
                  onChange={handleAddInputChange}
                  placeholder="Name"
                />
              </label>
              <label className="flex flex-col">
                title
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="title"
                  value={addData.title}
                  onChange={handleAddInputChange}
                  placeholder="Title"
                />
              </label>
              <label className="flex flex-col">
                title (AR)
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="titlear"
                  value={addData.titlear}
                  onChange={handleAddInputChange}
                  placeholder="Title (AR)"
                />
              </label>
              <label className="flex flex-col">
                artist
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="artist"
                  value={addData.artist}
                  onChange={handleAddInputChange}
                  placeholder="Artist"
                />
              </label>
              <label className="flex flex-col">
                artist (AR)
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="artistar"
                  value={addData.artistar}
                  onChange={handleAddInputChange}
                  placeholder="Artist (AR)"
                />
              </label>
              <label className="flex flex-col">
                album
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="album"
                  value={addData.album}
                  onChange={handleAddInputChange}
                  placeholder="Album"
                />
              </label>
              <label className="flex flex-col">
                album (AR)
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="albumar"
                  value={addData.albumar}
                  onChange={handleAddInputChange}
                  placeholder="Album (AR)"
                />
              </label>
              <label className="flex flex-col">
                length
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="length"
                  value={addData.length}
                  onChange={handleAddInputChange}
                  placeholder="Length"
                />
              </label>
              <label className="flex flex-col">
                Lyrics
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="lyrics"
                  value={addData.lyrics}
                  onChange={handleAddInputChange}
                  placeholder="Lyrics"
                />
              </label>
              <label className="flex flex-col">
                Lyrics (AR)
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="lyricsar"
                  value={addData.lyricsar}
                  onChange={handleAddInputChange}
                  placeholder="Lyrics (AR)"
                />
              </label>
              <label className="flex flex-col">
                composer
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="composer"
                  value={addData.composer}
                  onChange={handleAddInputChange}
                  placeholder="Composer"
                />
              </label>
              <label className="flex flex-col">
                composer (AR)
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="composerar"
                  value={addData.composerar}
                  onChange={handleAddInputChange}
                  placeholder="Composer (AR)"
                />
              </label>
              <label className="flex flex-col">
                musicarrangement
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="musicarrangement"
                  value={addData.musicarrangement}
                  onChange={handleAddInputChange}
                  placeholder="Music Arrangement"
                />
              </label>
              <label className="flex flex-col">
                musicarrangement (AR)
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="musicarrangementar"
                  value={addData.musicarrangementar}
                  onChange={handleAddInputChange}
                  placeholder="Music Arrangement (AR)"
                />
              </label>
              <label className="flex flex-col">
                rite
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="rite"
                  value={addData.rite}
                  onChange={handleAddInputChange}
                  placeholder="Rite"
                />
              </label>
              <label className="flex flex-col">
                rite (AR)
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="ritear"
                  value={addData.ritear}
                  onChange={handleAddInputChange}
                  placeholder="Rite (AR)"
                />
              </label>
              <label className="flex flex-col">
                occasion
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="occasion"
                  value={addData.occasion}
                  onChange={handleAddInputChange}
                  placeholder="Occasion"
                />
              </label>
              <label className="flex flex-col">
                occasion (AR)
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="occasionar"
                  value={addData.occasionar}
                  onChange={handleAddInputChange}
                  placeholder="Occasion (AR)"
                />
              </label>
              <label className="flex flex-col">
                Keywords
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="keywords"
                  value={addData.keywords}
                  onChange={handleAddInputChange}
                  placeholder="Keywords"
                />
              </label>
              <label className="flex flex-col">
                Keywords (AR)
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="keywordsar"
                  value={addData.keywordsar}
                  onChange={handleAddInputChange}
                  placeholder="Keywords (AR)"
                />
              </label>
              <label className="flex flex-col">
                Times
                <input
                  className="p-2 rounded-lg bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border text-light-text dark:text-dark-text placeholder-light-muted dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-light-brand/30 dark:focus:ring-dark-brand/30 focus:border-light-brand dark:focus:border-dark-brand transition-colors"
                  name="times"
                  value={addData.times}
                  onChange={handleAddInputChange}
                  placeholder="Times"
                />
              </label>
              <label className="flex flex-col">
                Image
                <input
                  type="file"
                  name="image"
                  accept="image/*"
                  onChange={(e) =>
                    setAddData((prev) => ({
                      ...prev,
                      imageFile: e.target.files[0],
                    }))
                  }
                />
              </label>
              <label className="flex flex-col">
                Audio (.mp3)
                <input
                  type="file"
                  name="audio"
                  accept="audio/mpeg"
                  onChange={(e) =>
                    setAddData((prev) => ({
                      ...prev,
                      audioFile: e.target.files[0],
                    }))
                  }
                />
              </label>
            </div>

            <div className="flex justify-end mt-6 gap-2">
              <button
                onClick={() => {
                  setShowModalAdd(false);
                }}
                className="px-4 py-2 rounded-lg border border-light-border dark:border-dark-border text-light-text dark:text-dark-text hover:bg-light-surfaceSoft dark:hover:bg-dark-surfaceSoft transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={showModalEdit ? handleUpdate : handleAdd}
                className="bg-light-brand hover:bg-light-brandHover dark:bg-dark-brand dark:hover:bg-dark-brandHover active:bg-light-brand dark:active:bg-dark-brand transition-colors px-4 py-2 rounded-lg text-white"
              >
                Add
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Rhyms;
